export default __webpack_public_path__ + "static/smart-terminal-752541ddf32111d0e843e709b1cc3d64.jpg";